<template>
  <ul class="timeline">

    <component
      :is="item.type == 'OrderReturnLog' ? 'order-return-timeline-item' : 'order-status-timeline-item'"
      v-for="item in items"
      :item="item"
    />

    <order-likuiduar-timeline-item v-if="barazim != null" :item="barazim"></order-likuiduar-timeline-item>
  </ul>
</template>

<script>
import OrderStatusTimelineItem from '@/Shared/OrderStatusTimelineItem'
import OrderLikuiduarTimelineItem from '@/Shared/OrderLikuiduarTimelineItem'
import OrderReturnTimelineItem from "@/Shared/OrderReturnTimelineItem";

export default {
  name: 'OrderStatusTimeline',
  components: {OrderReturnTimelineItem, OrderStatusTimelineItem, OrderLikuiduarTimelineItem},
  props: {
    items: Object,
    barazim: Object,
  }
}
</script>
